import { IndustryConfig } from '../../../types'

export const constructionEquipmentConfig: IndustryConfig = {
  id: 'construction-equipment',
  name: 'Construction Equipment',
  icon: '🏗️',
  description: 'Construction equipment sales, rental, and service providers',
  
  businessTypes: [
    {
      id: 'equipment-dealer',
      name: 'Equipment Dealer',
      description: 'New and used construction equipment sales'
    },
    {
      id: 'rental-company',
      name: 'Rental Company',
      description: 'Equipment rental and short-term leasing'
    },
    {
      id: 'service-repair',
      name: 'Service & Repair',
      description: 'Equipment maintenance and repair services'
    }
  ],
  
  revenueStreamTypes: [
    {
      id: 'equipment-sales',
      name: 'Equipment Sales',
      description: 'New and used equipment sales revenue',
      intelligenceValue: "We'll monitor construction market trends and equipment demand cycles."
    },
    {
      id: 'rental-revenue',
      name: 'Rental Revenue',
      description: 'Daily, weekly, and monthly rental income',
      intelligenceValue: "We'll track construction activity levels and seasonal demand patterns."
    },
    {
      id: 'service-maintenance',
      name: 'Service & Maintenance',
      description: 'Repair services and maintenance contracts',
      intelligenceValue: "We'll monitor equipment age demographics and service interval changes."
    }
  ],
  
  supplierCategories: [
    {
      id: 'oem-manufacturers',
      name: 'OEM Manufacturers',
      suppliers: ['Caterpillar', 'John Deere', 'Komatsu', 'Volvo CE'],
      spendRanges: ['Under $50K', '$50K-$200K', '$200K-$500K', 'Over $500K']
    }
  ],
  
  competitiveFactors: [
    'Equipment inventory depth',
    'Service response time',
    'Technical expertise',
    'Geographic coverage'
  ]
}
